import React from "react";
//#region types
import { WelcomeGuideTooltipProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid, Tooltip, TooltipProps } from "@mui/material";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const WelcomeGuideTooltip: React.FC<WelcomeGuideTooltipProps & TooltipProps> = (props) => {
  return (
    <Tooltip
      disableInteractive
      placement={props.placement}
      open={props.open}
      classes={{
        tooltip: cssExports.welcomeGuideToolTip,
        tooltipPlacementRight: clsx(cssExports.welcomeGuideToolTipArrowLeft, cssExports.welcomeGuideToolTipContainer),
        tooltipPlacementTop: clsx(cssExports.welcomeGuideToolTipArrowBottom, cssExports.welcomeGuideToolTipContainer),
        tooltipPlacementBottom: clsx(cssExports.welcomeGuideToolTipArrowTop, cssExports.welcomeGuideToolTipContainer),
      }}
      title={
        <Grid container direction="row">
          <Grid item className={clsx(cssExports.heading, cssExports.welcomeGuideToolTip)}>
            {props.title}
          </Grid>
          <Grid item className={clsx(cssExports.content, cssExports.welcomeGuideToolTip)}>
            {props.content}
          </Grid>
        </Grid>
      }
    >
      {
        <Grid item container>
          {props.children}
        </Grid>
      }
    </Tooltip>
  );
};
export default WelcomeGuideTooltip;
